import { render, staticRenderFns } from "./KiosksFeatureFlagSwitcher.vue?vue&type=template&id=09b36f0a"
import script from "./KiosksFeatureFlagSwitcher.vue?vue&type=script&lang=js"
export * from "./KiosksFeatureFlagSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports